<template>
  <div class="pagar-reserva-container">
    <!-- Loading -->
    <div v-if="cargando" class="text-center">
      <p>Cargando...</p>
    </div>

    <!-- Opciones de pago -->
    <div v-if="mostrarOpciones" class="main-card">
      <h4 class="titulo">Seleccione tipo de pago</h4>
      
      <div class="botones-container">
        <button class="btn-opcion" @click="irPagarPorHabitacion">
          <span>Pagar</span>
          <span>por</span>
          <span>Habitaciones</span>
        </button>

        <button class="btn-opcion" @click="irPagarReservaCompleta">
          <span>Pagar todo</span>
        </button>
      </div>

      <p class="text-danger text-center mt-3 mb-3">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>
        <small>Una vez seleccionada, la forma de pago no podrá ser cambiada.</small>
      </p>

      <button class="btn-regresar" @click="volver">
        ← Regresar
      </button>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { API_URL } from '@/config/config.js'

export default {
  name: 'PagarReservaHotel',
  data() {
    return {
      route: useRoute(),
      router: useRouter(),
      cargando: true,
      mostrarOpciones: false
    }
  },
  async mounted() {
    const id = this.route.params.id
    await this.verificarPreferencia(id)
  },
  methods: {
    async verificarPreferencia(id) {
      try {
        const res = await axios.get(`${API_URL}/reservas/${id}/cantidad-habitaciones`)
        const { preferenciaPago } = res.data

        // Si preferenciaPago es 1, ir directo a pagar por habitación
        if (preferenciaPago === 1) {
          this.router.push(`/pagar-por-habitacion/${id}`)
          return
        }

        // Si preferenciaPago es 2, ir directo a pagar reserva completa
        if (preferenciaPago === 2) {
          this.router.push(`/pagar-reserva-completa/${id}`)
          return
        }

        // Si preferenciaPago es 0, actualizar a 1 y redirigir
        if (preferenciaPago === 0) {
          await axios.post(`${API_URL}/reservas/${id}/preferencia-pago`, {
            preferencia_pago: 1
          })
          this.router.push(`/pagar-por-habitacion/${id}`)
          return
        }

        // Si por alguna razón no entra en los casos anteriores, mostrar opciones
        this.mostrarOpciones = true
        this.cargando = false

      } catch (error) {
        console.error('Error al verificar preferencia de pago:', error)
        this.cargando = false
      }
    },
    async irPagarPorHabitacion() {
      const id = this.route.params.id
      try {
        await axios.post(`${API_URL}/reservas/${id}/preferencia-pago`, {
          preferencia_pago: 1
        })
        this.router.push(`/pagar-por-habitacion/${id}`)
      } catch (error) {
        console.error('Error al guardar preferencia:', error)
        this.router.push(`/pagar-por-habitacion/${id}`)
      }
    },
    async irPagarReservaCompleta() {
      const id = this.route.params.id
      try {
        await axios.post(`${API_URL}/reservas/${id}/preferencia-pago`, {
          preferencia_pago: 2
        })
        this.router.push(`/pagar-reserva-completa/${id}`)
      } catch (error) {
        console.error('Error al guardar preferencia:', error)
        this.router.push(`/pagar-reserva-completa/${id}`)
      }
    },
    volver() {
      this.router.push('/reservas')
    }
  }
}
</script>

<style scoped>
.pagar-reserva-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  padding: 20px;
}

.main-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 30px 40px;
  text-align: center;
}

.titulo {
  margin: 0 0 25px 0;
  color: #333;
  font-weight: 500;
}

.botones-container {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 25px;
}

.btn-opcion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
